import type { QueryFunctionContext } from '@tanstack/react-query';
import { gqlClient } from '@/utilities/graphQLClient';
import { gql } from '@/utilities/gql';
import { NOTE_FRAGMENT } from './note-fragment';

type QueryContext = QueryFunctionContext<[string, string | undefined]>;

export const queryFn = async ({ queryKey: [_, companyId] }: QueryContext) => {
  if (typeof companyId === 'undefined') {
    return Promise.reject(new Error('Invalid company id'));
  }
  const response = await gqlClient.request(
    gql(
      `
      query getCompanyNotes($companyId: String!) {
        CompanyNotes(companyId: $companyId) {
          ...NoteFields
        }
      }
    `,
      [NOTE_FRAGMENT]
    ),
    { companyId }
  );

  if ('CompanyNotes' in response) {
    return response.CompanyNotes;
  }

  return [];
};
